module.exports = __webpack_public_path__ + "gu.svg?4605ab0276a72f771320afe88eb4bd52";